export default __webpack_public_path__ + "static/media/Exclamação Círculo.8693a3b8.svg";